export const devicesStatusColors = {
  0: "error",
  10: "success",
};

export const devicesStatusLabels = {
  0: "common.innactive",
  10: "common.active",
};